module.exports = new __parcel__URL__("google-drive@2x.4ef329b2.png").toString();